
export class AssignmentRulesEvent {
  static ASSIGNMENT_RULE_EDITED = 'assignment_rule_edited';
  static ASSIGNMENT_RULE_CREATED = 'assignment_rule_created';
  static ASSIGNMENT_RULE_USER_SELECTED = 'assignment_rule_user_selected';
}
